// @flow
import * as React from 'react';
import { EntypoChevronSmallLeft } from 'react-entypo-icons';
import cx from 'classname';
import { withStyles } from '@phg/stilo-toolbox/components/ThemeProvider/index';
import { Link } from '@phg/stilo-toolbox/v2/component';
import l from 'app/Translate';
import makeStyle from './PreviousStep.style';

type PreviousStepProps = {
    classes: {
        Arrow: string,
        PreviousStep: string,
        Text: string
    },
    className?: string
};

const PreviousStep = ({ classes, className, ...props }: PreviousStepProps) => (
    <Link
        {...props}
        className={cx(classes.PreviousStep, className)}
    >
        <EntypoChevronSmallLeft valign className={classes.Arrow} />
        <span className={classes.Text}>{l('Previous step')}</span>
    </Link>
);

export default withStyles(makeStyle)(PreviousStep);
